import { ReactNode, useMemo } from 'react'
import {
  FaExclamationCircle,
  FaExclamationTriangle,
  FaInfoCircle
} from 'react-icons/fa'

const iconComponent = {
  info: FaInfoCircle,
  warning: FaExclamationTriangle,
  error: FaExclamationCircle
}

export interface NoteProps {
  children: ReactNode
  variant?: 'outlined' | 'solid'
  type?: 'warning' | 'info' | 'error'
  className?: string
}

export const Note = ({
  children,
  className = '',
  variant = 'solid',
  type = 'info'
}: NoteProps) => {
  const IconComponent = iconComponent[type]

  const cardClasses = useMemo(() => {
    if (variant === 'solid') {
      switch (type) {
        case 'info':
          return 'bg-aquaSpring border border-mostlyGreen'
        case 'warning':
          return 'bg-[#FFEBCE] border border-[#F59300]'
        case 'error':
          return 'bg-red-300 border border-red-600'
        default:
          return ''
      }
    }
    switch (type) {
      case 'info':
        return 'border border-aquaSpring'
      case 'warning':
        return 'border border-[#F59300]'
      case 'error':
        return 'border border-red-300'
      default:
        return ''
    }
  }, [type, variant])

  const iconColor = useMemo(() => {
    switch (type) {
      case 'info':
        return 'text-mostlyGreen'
      case 'warning':
        return 'text-[#F59300]'
      case 'error':
        return 'text-error'
      default:
        return ''
    }
  }, [type])

  return (
    <div
      className={`mb-5 md:mb-10 flex flex-row gap-[10px] px-4 py-4 w-full rounded-[10px] ${cardClasses} ${className}`}
    >
      <div className='flex space-x-4 items-start'>
        <IconComponent
          width={26}
          height={26}
          className={`mt-[3px] shrink-0 ${iconColor}`}
        />
        <div>{children}</div>
      </div>
    </div>
  )
}
